"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuerySelectValue = exports.getQuerySelectValue = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
// get value recursively and handle values from arrays
function recursiveGet(value, path) {
    let index = 0;
    let current = value;
    const parts = path.split('.');
    while (current !== null &&
        typeof current !== 'undefined' &&
        index < parts.length &&
        parts[index]) {
        // if current value is an array, loop through items
        // and use the remaining path as the nextPath
        if (Array.isArray(current)) {
            const nextPath = parts.slice(index).join('.');
            return current.map(item => recursiveGet(item, nextPath)).join(', ');
        }
        current = (0, lodash_1.get)(current, parts[index++]);
    }
    return current;
}
function getEntityDataPath(selection, expressionMap) {
    var _a;
    const [alias, property] = selection.split('.');
    const mainAliasName = (_a = expressionMap === null || expressionMap === void 0 ? void 0 : expressionMap.mainAlias) === null || _a === void 0 ? void 0 : _a.name;
    const isRelation = alias !== mainAliasName;
    // no relation so selection is direct property of the entiy data
    if (!isRelation) {
        return property;
    }
    // if relation, then get full qualified path to value
    const buildJoinAliasPath = (aliasName, path = '') => {
        var _a;
        const joinAttribute = (_a = expressionMap === null || expressionMap === void 0 ? void 0 : expressionMap.joinAttributes) === null || _a === void 0 ? void 0 : _a.find(j => j.alias.name === aliasName);
        const [parentAlias, parentProperty] = joinAttribute
            ? joinAttribute.entityOrProperty.split('.')
            : [];
        if (!parentAlias) {
            throw new Error(`No parent alias found for "${aliasName}" in selection "${selection}" for path "${path}"`);
        }
        path = `${parentProperty}.${path}`;
        return parentAlias === mainAliasName
            ? path + property
            : buildJoinAliasPath(parentAlias, path);
    };
    return buildJoinAliasPath(alias);
}
/**
 * Get the query select value of item.
 */
function getQuerySelectValue(options) {
    var _a, _b;
    const { item, select, expressionMap, noTransform } = options;
    const [alias, property] = select.selection.split('.');
    const isRelation = alias !== ((_a = expressionMap === null || expressionMap === void 0 ? void 0 : expressionMap.mainAlias) === null || _a === void 0 ? void 0 : _a.name);
    // if select is from subQuery, get() directly from item
    const isJoinSubQuery = isRelation &&
        !!((_b = expressionMap === null || expressionMap === void 0 ? void 0 : expressionMap.joinAttributes) === null || _b === void 0 ? void 0 : _b.some(a => {
            return a.alias && a.alias.name === alias && a.alias.subQuery;
        }));
    let value;
    if (select.pluginType) {
        value = item[select.selection];
    }
    else if (Array.isArray(item[alias])) {
        value = item[alias].map((c) => c[property]).join(', ');
    }
    else if (isJoinSubQuery) {
        value = (0, lodash_1.get)(item, property);
    }
    else {
        // get full qualified path to entity data value (e.g. deep nested relationships)
        const path = getEntityDataPath(select.selection, expressionMap);
        value = recursiveGet(item, path);
    }
    if (noTransform) {
        // if no transform, do nothing and skip other checks
    }
    else if (Array.isArray(value)) {
        value = value.join(', ');
    }
    else if (typeof value !== 'undefined' && value !== null) {
        value = value.toString();
    }
    return value;
}
exports.getQuerySelectValue = getQuerySelectValue;
function useQuerySelectValue(options) {
    return (0, react_1.useMemo)(() => getQuerySelectValue(options), [options]);
}
exports.useQuerySelectValue = useQuerySelectValue;
//# sourceMappingURL=useQuerySelectValue.js.map